<template>
  <el-dialog
    title=""
    :visible.sync="isShowModel"
    top="0"
    :close-on-click-modal="false"
    width="480px"
    :show-close="false"
    custom-class="vipIntercept"
  >
    <div class="dialog-head">
      <fm-button
        @click="handleClose"
        type="info"
        size="mini"
        text
        icon="icon-model-close"
      ></fm-button>
    </div>
    <div class="dialog-content">
      <img
        :class="{ bImg: vip_mode === 'B' }"
        :src="
          vip_mode === 'B'
            ? $utils.getPng('CurtailBox')
            : $utils.getPng('vipTips_icon')
        "
      />
      <span class="title">{{ vipTxt }}</span>
      <span class="desc" v-show="btnShow"
        >开通VIP典藏版或Pro会员无限次下载</span
      >
      <div class="btn">
        <span class="plainBtn" @click="handleClose" v-if="btnShow"
          >不了，谢谢</span
        >
        <span :class="['primaryBtn', { primaryBtn2: btnShow }]" @click="goVip"
          >升级会员</span
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShowModel: Boolean,
    btnShow: Boolean,
    vipTxt: String,
    vip_mode: String,
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    goVip() {
      this.$emit('openVip')
    },
  },
}
</script>

<style></style>
